import { MessageSquarePlus, View } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from 'ui/components/Tabs';

import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { useResponsive } from 'utils/useMediaQuery';
import { cn } from '../../../../utils/cn';
import { RootState } from '../../store';
import { getBrowseMode, setBrowseMode, setSidebarOpen } from '../../store/uiSlice';

export const Mode = () => {
  const { t } = useTranslation();
  const browseMode = useSelector((state: RootState) => getBrowseMode(state));
  const dispatch = useDispatch();
  const { isMobile } = useResponsive();
  const handleTabChange = (value: string) => {
    if (value === 'browse') {
      dispatch(setBrowseMode(true));
    } else if (value === 'comment') {
      dispatch(setBrowseMode(false));
      dispatch(setSidebarOpen(true));
    }
  };

  return (
    <Tabs
      defaultValue="comment"
      value={browseMode ? 'browse' : 'comment'}
      className="preview flex w-full flex-col items-center justify-center z-10"
      onValueChange={(value) => handleTabChange(value as string)}
    >
      <Tabs.List className="bg-background h-9 w-auto grid-cols-2 gap-0.5 py-0.5">
        <Tabs.Trigger
          value="browse"
          className={cn(
            'flex h-7 rounded-[4px] px-2 focus-visible:outline-none focus-visible:ring-0',
            browseMode ? 'px-2 md:px-1.5' : 'gap-0.5'
          )}
        >
          <View size={18} focusable="false" tabIndex={-1} className='pointer-events-none select-none' />
          <AnimatePresence mode="wait">
            {!browseMode && !isMobile && (
              <motion.div
                initial={{ width: 0, opacity: 0, marginLeft: 0 }}
                animate={{ width: 'auto', opacity: 1, marginLeft: 5, marginRight: 5 }}
                exit={{
                  width: 0, opacity: 0, marginLeft: 0,
                  transition: { delay: 0.4 }
                }}
                transition={{ duration: 0.4, delay: 0.75, type: 'spring', stiffness: 300, damping: 16, mass: 0.5 }}
                className='overflow-hidden'
              >
                {t('bottom_bar.mode.browse', 'Browse')}</motion.div>
            )}
          </AnimatePresence>
        </Tabs.Trigger>
        <Tabs.Trigger
          value="comment"
          className={cn(
            'flex h-7 rounded-[4px] px-2 focus-visible:outline-none focus-visible:ring-0',
            browseMode ? ' px-2 md:px-1.5' : ''
          )}
        >
          <MessageSquarePlus size={18} focusable="false" tabIndex={-1} className='pointer-events-none select-none' />
          <AnimatePresence mode="wait">
            {!browseMode && !isMobile && (
              <motion.div
                initial={{ width: 0, opacity: 0, marginLeft: 0 }}
                animate={{ width: 'auto', opacity: 1, marginLeft: 5, marginRight: 5 }}
                exit={{
                  width: 0, opacity: 0, marginLeft: 0,
                  transition: { delay: 0.4 }
                }}
                transition={{ duration: 0.4, delay: 0.75, type: 'spring', stiffness: 300, damping: 16, mass: 0.5 }}
                className='overflow-hidden'
              >
                {t('bottom_bar.mode.comment', 'Comment')}</motion.div>
            )}
          </AnimatePresence>
        </Tabs.Trigger>
      </Tabs.List>
    </Tabs>
  );
};
